<!--
  Created 21.02.2024
  Originated from Tailwind UI component: Data Display, Stats, With brand icon
  https://tailwindui.com/components/application-ui/data-display/stats#component-0d73a2494863902616f059ddcb5da2d5
-->
<template>
  <div>
    <h3
      v-if="heading"
      class="text-lg font-medium text-gray-800">
      {{ heading }}
    </h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <div
        v-for="item in stats"
        :key="item.id"
        class="relative overflow-hidden rounded-lg bg-white px-4 pt-5 shadow sm:px-6 sm:pt-6"
        :class="[item.link ? 'pb-12' : 'pb-0']">
        <!-- Figure term -->
        <dt>
          <div class="absolute rounded-md bg-indigo-500 p-3">
            <component
              :is="item.icon"
              class="size-6 text-white"
              aria-hidden="true" />
          </div>
          <p class="ml-16 truncate text-sm font-medium text-gray-500">
            {{ item.name }}
          </p>
        </dt>
        <!-- Figure term description -->
        <dd class="ml-16 flex items-baseline pb-6 sm:pb-7">
          <p class="text-2xl font-semibold text-gray-900">
            {{ item.stat }}
          </p>
          <p
            :class="[item.stat > item.statPrevious ? 'text-green-500' : (item.stat === item.statPrevious ? 'text-yellow-500' : 'text-red-500'),
                     'ml-2 flex items-baseline text-sm font-semibold']"
            :title="'Previous period: ' + item.statPrevious">
            <ArrowUpIcon
              v-if="item.stat > item.statPrevious"
              class="size-4 shrink-0 self-center text-green-500"
              aria-hidden="true" />
            <ArrowsUpDownIcon
              v-else-if="item.stat === item.statPrevious"
              class="size-4 shrink-0 self-center text-yellow-500"
              aria-hidden="true" />
            <ArrowDownIcon
              v-else
              class="size-4 shrink-0 self-center text-red-500"
              aria-hidden="true" />
            <span class="sr-only"> {{ item.stat > item.statPrevious ? 'Increased' : (item.stat === item.statPrevious ? 'Unchanged' : 'Decreased') }} by </span>
            <span class="ml-0.5">{{ item.stat - item.statPrevious }}</span>
            <span class="sr-only"> compared to previous period </span>
          </p>
          <!-- Figure footer -->
          <div
            v-if="item.link"
            class="absolute inset-x-0 bottom-0 bg-gray-50 p-4 sm:px-6">
            <div class="text-sm">
              <a
                href="#"
                class="font-medium text-indigo-600 hover:text-indigo-500">View all<span class="sr-only"> {{ item.name }} stats</span></a>
            </div>
          </div>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script setup>
import {
  ArrowDownIcon, ArrowUpIcon, ArrowsUpDownIcon,
} from '@heroicons/vue/20/solid';

defineProps({
  heading: {
    type: String,
    required: false,
    default: 'Last 30 days',
  },
  /**
   * The stats to display.
   * @type {Array} - Array of objects.
   * @example { id: 1, name: 'Total Subscribers', stat: 718, statPrevious: 520, icon: UsersIcon, link: 'route("dashboard")'}
   */
  stats: {
    type: Array,
    required: true,
    default: () => [],
    validator(value) {
      return value.every((item) => (
        item.id
        && typeof item.name === 'string'
        && typeof item.stat === 'number'
        && typeof item.statPrevious === 'number'
        && item.icon
        && (item.link === undefined || typeof item.link === 'string')
      ));
    },
  },
});

</script>
